import * as Yup from 'yup';
import { CreateJobFormSteps } from './types';

const nullableString = Yup.string()
    .transform((v) => (v === '' ? null : v))
    .nullable();

const JOB_REFERENCE_MAX_LENGTH = 16;
const JOB_REFERENCE_PATTERN = /^[A-Za-z0-9-]+$/;

export const jobSectionValidationSchema = Yup.object({
    jobId: Yup.string()
        .trim()
        .transform((v) => (v === '' ? null : v))
        .nullable()
        .required('Job reference is required')
        .matches(JOB_REFERENCE_PATTERN, 'Job reference may contain only letters, digits or hyphens')
        .max(JOB_REFERENCE_MAX_LENGTH, `Job reference must not exceed ${JOB_REFERENCE_MAX_LENGTH} characters`),
});

export const customerSectionValidationSchema = Yup.object({
    customerId: nullableString.required('Customer is required'),
});

export const getDeliveryTermsSectionValidationSchema = (required: boolean) =>
    Yup.object({
        incotermCode: required ? nullableString.required('Incoterm is required') : nullableString.notRequired(),
    });

export const teamSectionValidationSchema = Yup.object({
    teamId: nullableString.required('Team is required'),
});

export const assignAgentSectionValidationSchema = Yup.object({
    assignedAgent: nullableString.notRequired(),
});

export const createJobValidationSchema = (requiredDeliveryTerms: boolean) =>
    Yup.object({
        [CreateJobFormSteps.JOB]: jobSectionValidationSchema,
        [CreateJobFormSteps.CUSTOMER]: customerSectionValidationSchema,
        [CreateJobFormSteps.DELIVERY_TERMS]: getDeliveryTermsSectionValidationSchema(requiredDeliveryTerms),
        [CreateJobFormSteps.TEAM]: teamSectionValidationSchema,
        [CreateJobFormSteps.ASSIGN_AGENT]: assignAgentSectionValidationSchema,
    });

export const getCreateJobSectionSchemas = (requiredDeliveryTerms: boolean) => ({
    [CreateJobFormSteps.JOB]: jobSectionValidationSchema,
    [CreateJobFormSteps.CUSTOMER]: customerSectionValidationSchema,
    [CreateJobFormSteps.DELIVERY_TERMS]: getDeliveryTermsSectionValidationSchema(requiredDeliveryTerms),
    [CreateJobFormSteps.TEAM]: teamSectionValidationSchema,
    [CreateJobFormSteps.ASSIGN_AGENT]: assignAgentSectionValidationSchema,
});

export type CreateJobFormFields = {
    [CreateJobFormSteps.JOB]: { jobId: string | null };
    [CreateJobFormSteps.CUSTOMER]: { customerId: string | null };
    [CreateJobFormSteps.DELIVERY_TERMS]: { incotermCode: string | null };
    [CreateJobFormSteps.TEAM]: { teamId: string | null };
    [CreateJobFormSteps.ASSIGN_AGENT]: { assignedAgent: string | null };
};
